import { Box, CampoEstatico, TipoCampoEstatico } from '@intechprev/componentes-web';
import React from 'react';
import { WebCapitalSeguradoEntidade } from '../../../entidades';

interface IProps {
  capitalSegurado: WebCapitalSeguradoEntidade | null;
  valorInvalidez: number;
}

export const CapitalSegurado: React.FC<IProps> = ({
  capitalSegurado,
  valorInvalidez
}) => {
  if (capitalSegurado === null) {
    return null;
  }

  return (
    <Box titulo={"Capital Segurado"} >
      <div className={"table-responsive"}>
        <table className={"table"}>
          <thead>
            <tr>
              <th className={"text-center"}>
                {"CAPITAL SEGURADO"}
                <br />
                {"RISCO EXCEDENTE DE MORTE"}
              </th>
              <th className={"text-center"}>
                {"CAPITAL SEGURADO"}
                <br />
                {"RISCO EXCEDENTE DE INVALIDEZ"}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={"text-center"}>
                <CampoEstatico
                  valor={capitalSegurado.VAL_CAP_SEG_MORTE}
                  tipo={TipoCampoEstatico.dinheiro}
                />
              </td>
              <td className={"text-center"}>
                <CampoEstatico
                  valor={capitalSegurado.VAL_CAP_SEG_INVALIDEZ}
                  tipo={TipoCampoEstatico.dinheiro}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <br />

      <p>
        <b>{"Pecúlio por Morte"}</b>
        <br />
        {"Em caso de falecimento de Participante ou Assistido com salário de participação acima do limite de "}
        <CampoEstatico valor={valorInvalidez} tipo={TipoCampoEstatico.dinheiro} />
        {` (Jan./${capitalSegurado.ANO}), a PREVIRB ficará responsável pelo pagamento do benefício até o valor equivalente a 20 vezes o limite de salário de participação, no valor de `}
        <CampoEstatico valor={valorInvalidez} tipo={TipoCampoEstatico.dinheiro} />
        {" x 20, ou seja, até "}
        <CampoEstatico valor={valorInvalidez * 20} tipo={TipoCampoEstatico.dinheiro} />
        {", já o excedente ficará a cargo do seguro contratado, equivalente a 20 vezes a média dos 12 últimos salários de participação até o limite regulamentar, a parcela dos salários de participação acima do respectivo limite, ficará a cargo do seguro contratado."}
      </p>

      <p>
        <b>{"Renda de Aposentadoria por Invalidez"}</b>
        <br />
        {"Em caso de sinistro, a PREVIRB será responsável pela constituição da Provisão Matemática de Benefícios Concedidos por Invalidez até o limite de Salário de Participação de "}
        <CampoEstatico valor={valorInvalidez} tipo={TipoCampoEstatico.dinheiro} />
        {". Acima desse limite, a seguradora será responsável pela constituição do restante da Provisão relativa ao excesso do Salário de Participação sobre o limite."}
      </p>

      <p>
        <b>{"Custeio do seguro"}</b>
        <br />
        {"O prêmio do seguro do risco excedente será custeado pelo Patrocinador para todos os Ativos. Os Autopatrocinados, Remidos e Assistidos, que optarem por esta cobertura, serão responsáveis pelo custeio integral do seu seguro, por opção."}
      </p>
    </Box>
  );
}